import {
  SET_TRAILS,
  SET_SUGGESTED_TRAILS,
  SET_CURRENT_TRAIL,
  NAVIGATE_TO_TRAIL,
  RESET_CURRENT_TRAIL,
  TrailsActionsTypes,
} from "./TrailsActions";
import { CustomTrail } from "../../../types/tour";

interface Trails {
  trails: CustomTrail[];
  suggestedTrails: CustomTrail[];
  currentTrailIndex: number | null;
  currentTrailId: string | null;
}

const initialState: Trails = {
  trails: [],
  suggestedTrails: [],
  currentTrailIndex: null,
  currentTrailId: null,
};

const TrailsReducer = (state = initialState, action: TrailsActionsTypes) => {
  switch (action.type) {
    case SET_TRAILS:
      return { ...state, trails: [...state?.trails, action?.payload] };

    case SET_SUGGESTED_TRAILS:
      return {
        ...state,
        suggestedTrails: action?.payload ? [...action?.payload] : [],
      };

    case SET_CURRENT_TRAIL:
      return {
        ...state,
        currentTrailIndex: action.payload,
      };

    case NAVIGATE_TO_TRAIL: {
      const newState = {
        ...state,
        currentTrailIndex: action.payload.trailIndex,
        currentTrailId: action.payload.trailId,
      };
      return newState;
    }

    case RESET_CURRENT_TRAIL:
      return {
        ...state,
        currentTrailIndex: null,
        currentTrailId: null,
      };

    default:
      return state;
  }
};

export default TrailsReducer;
